import {ScrollLock} from '../utils/scroll-lock';
import {FocusLock} from '../utils/focus-lock';

const scrollLock = new ScrollLock();
const focusLock = new FocusLock();

const initMenu = () => {
  const toggleBtn = document.querySelector('.main-nav__toggle');
  const closeMenuBtn = document.querySelector('.main-nav__close');
  const menuTop = document.querySelector('.main-nav--top');
  const menuBottom = document.querySelector('.main-nav--bottom');
  const header = document.querySelector('.header');
  const headerInner = document.querySelector('.header__inner');
  const headerLinks = document.querySelectorAll('.main-nav__link');
  const overlay = document.querySelector('.bg-overlay');

  headerLinks.forEach((item) => {
    item.addEventListener('click', (evt) => {
      evt.preventDefault();

      if (menuBottom.classList.contains('show')) {
        closeMenu();
      }
    });
  });

  const closeMenu = () => {
    closeMenuBtn.classList.remove('show');
    toggleBtn.classList.remove('hide');
    menuTop.classList.remove('show');
    menuBottom.classList.remove('show');
    setTimeout(() => {
      // headerInner.style.height = '240px';
      // headerInner.classList.add('fixed-height');
      headerInner.style.height = null;
      setTimeout(() => {
        window.enableBodyScroll(menuBottom);
      }, 300);
      focusLock.unlock();
      overlay.classList.remove('is-active');
    }, 500);

  };

  if (closeMenuBtn) {
    closeMenuBtn.addEventListener('click', (evt) => {
      evt.preventDefault();
      closeMenu();
    });
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', (evt) => {
      evt.preventDefault();
      window.disableBodyScroll(menuBottom, {
        reserveScrollBarGap: true,
      });
      closeMenuBtn.classList.add('show');
      toggleBtn.classList.add('hide');
      menuTop.classList.add('show');
      menuBottom.classList.add('show');
      focusLock.lock('.header__inner');
      // headerInner.classList.remove('fixed-height');
      headerInner.style.height = 'auto';
      overlay.classList.add('is-active');
    });
  }

  const initStickyMenu = () => {
    let lastScroll = 0;
    const $stickyElement = document.querySelector('[data-sticky]');
    const headerHeight = header.offsetHeight;

    window.addEventListener('scroll', () => {
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      const isDirectionDown = currentScroll > 0 && lastScroll <= currentScroll;

      lastScroll = currentScroll;

      if ($stickyElement) {
        const hasStickyElement = $stickyElement.getBoundingClientRect().top < headerHeight;

        if ($stickyElement.offsetParent !== null) {
          document.body.classList.toggle('has-sticky-element', hasStickyElement);
        }
      }

      if (window.scrollY > headerHeight) {
        header.classList.add('is-fixed');
        menuTop.classList.add('sticky');
      } else {
        header.classList.remove('is-fixed');
        menuTop.classList.remove('sticky');
      }

      if (window.scrollY > headerHeight * 2 && !isDirectionDown) {
        document.body.classList.add('has-header');
      } else {
        document.body.classList.remove('has-header');
      }
    });
  };

  initStickyMenu();
};

export {initMenu};
